import { Lightbox, LightboxImage } from '@noticeable-app/noticeable-common'

import { isEmbedded } from './utility'

const lightbox = Lightbox.mount()
if (window.noticeable.accentColor) {
    lightbox.setAttribute('theme-color', window.noticeable.accentColor)
}

export function initializeLightbox() {
    if (isEmbedded()) {
        return
    }

    init()
}

export function registerFigureClickEventListeners(
    listener: (e: MouseEvent, lightboxImages: LightboxImage[], index: number) => void,
) {
    const publicationElements: Array<HTMLElement> = [
        ...document.querySelectorAll<HTMLElement>('article.listing-post, article.post'),
    ]

    for (const publicationElement of publicationElements) {
        const imageElements = [...publicationElement.querySelectorAll<HTMLImageElement>('figure img')]
        const lightboxImages: any[] = []

        imageElements.forEach((imageElement: HTMLImageElement, index: number) => {
            lightboxImages.push({
                caption: imageElement.alt ?? imageElement.title,
                url: imageElement.src,
            })
        })

        imageElements.forEach((imageElement: HTMLImageElement, index: number) => {
            imageElement.addEventListener('click', (e) => {
                listener(e, lightboxImages, index)
            })
        })
    }
}

function init() {
    registerFigureClickEventListeners((e, lightboxImages, index) => {
        e.preventDefault()
        lightbox.open(lightboxImages, index)
    })
}
